import PropTypes from "prop-types";
import { useAppContext } from "../../hooks";
import Unauthorized from "../Unauthorized";
import withErrorBoundary from "../withErrorBoundary";
import { Paper, Box, Divider } from "@mui/material";
import Title from "../Title";

RouteWrapper.propTypes = {
  onlyFor: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  actions: PropTypes.node,
  noPaperWrapper: PropTypes.bool,
};

function RouteWrapper({ onlyFor, children, title, actions, noPaperWrapper }) {
  const { data: appContext } = useAppContext();

  if (onlyFor) {
    if (!onlyFor.find((forRole) => appContext.userProfiles.includes(forRole))) {
      return <Unauthorized>Pro zobrazení obsahu nemáte dostatečné oprávnění.</Unauthorized>;
    }
  }

  // If no title is provided, return the children directly -> no wrapper is needed
  if (!title) return children;

  let routeHeader;
  if (actions) {
    routeHeader = (
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <Title sx={{ flexGrow: 1 }}>{title}</Title>
        <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
        {actions}
      </Box>
    );
  } else {
    routeHeader = <Title>{title}</Title>;
  }

  return !noPaperWrapper ? (
    <Paper sx={{ p: 2 }}>
      {routeHeader}
      {children}
    </Paper>
  ) : (
    <>
      {routeHeader}
      {children}
    </>
  );
}

export default withErrorBoundary(RouteWrapper, { spaLevel: true });
